module.exports = __webpack_public_path__ + "static/media/journal4.48b4e952.png";